// three r186 SkinnedMesh.applyBoneTransform은 Vector3 대상에서 `_baseVector.set(...target, 1)`로 펼침을 쓴다.
// 펼칠 때마다 Vector3[Symbol.iterator] 제너레이터·결과 객체가 생겨, 발 접지(groundContact)·발바닥 검사(kael soleSamples)처럼
// 프레임마다 수십~수백 정점을 읽는 곳에서 사냥 15초에 약 50MB를 할당했다(perf-first30 --alloc-stacks, 2026-11-03 PC 측정).
// 같은 계산을 펼침 없이 하는 판으로 프로토타입을 한 번 바꾼다. 결과는 원본과 같다(skinnedNoAlloc.test.ts).
import * as THREE from 'three/webgpu';

const skinIndex = new THREE.Vector4();
const skinWeight = new THREE.Vector4();
const baseVector = new THREE.Vector4();
const vector4 = new THREE.Vector4();
const matrix4 = new THREE.Matrix4();

type BoneTarget = THREE.Vector3 | THREE.Vector4;

/** 원본 applyBoneTransform과 같은 계산(할당 없음). */
export function applyBoneTransformNoAlloc(this: THREE.SkinnedMesh, index: number, target: BoneTarget): BoneTarget {
  const skeleton = this.skeleton;
  const attrs = this.geometry.attributes;
  skinIndex.fromBufferAttribute(attrs.skinIndex as THREE.BufferAttribute, index);
  skinWeight.fromBufferAttribute(attrs.skinWeight as THREE.BufferAttribute, index);
  const v4 = (target as THREE.Vector4).isVector4 === true;
  if (v4) {
    baseVector.copy(target as THREE.Vector4);
    (target as THREE.Vector4).set(0, 0, 0, 0);
  } else {
    baseVector.set(target.x, target.y, target.z, 1);
    (target as THREE.Vector3).set(0, 0, 0);
  }
  baseVector.applyMatrix4(this.bindMatrix);
  for (let i = 0; i < 4; i++) {
    const weight = skinWeight.getComponent(i);
    if (weight !== 0) {
      const boneIndex = skinIndex.getComponent(i);
      matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
      vector4.copy(baseVector).applyMatrix4(matrix4);
      if (v4) (target as THREE.Vector4).addScaledVector(vector4, weight);
      else { target.x += vector4.x * weight; target.y += vector4.y * weight; target.z += vector4.z * weight; }
    }
  }
  if (v4) (target as THREE.Vector4).w = baseVector.w;
  return target.applyMatrix4(this.bindMatrixInverse);
}

let installed = false;
/** 렌더러 생성 때 한 번 부른다(여러 번 불러도 한 번만 바꾼다). */
export function installSkinnedNoAlloc(): void {
  if (installed) return;
  installed = true;
  (THREE.SkinnedMesh.prototype as unknown as { applyBoneTransform: typeof applyBoneTransformNoAlloc }).applyBoneTransform = applyBoneTransformNoAlloc;
}
